import React, { createContext } from 'react';
import { usePopover } from '../Popover/usePopover';
export const PopoverContext = createContext({});
export const PopoverProvider = ({ children, placement, hasArrow, width, height, offset, isOpen, id, setIsOpen, }) => {
    const { popoverTriggerProps, popoverProps } = usePopover({
        placement,
        hasArrow,
        width,
        height,
        offset,
        isOpen,
        setIsOpen,
        id,
    });
    return React.createElement(PopoverContext.Provider, { value: { popoverTriggerProps, popoverProps } }, children);
};
